<template>
  <transition
    enter-active-class="transition ease-out duration-300"
    enter-from-class="translate-y-4 opacity-0"
    enter-to-class="translate-y-0 opacity-100"
    leave-active-class="transition ease-in duration-200"
    leave-from-class="translate-y-0 opacity-100"
    leave-to-class="translate-y-4 opacity-0"
  >
    <div
      v-if="visible"
      class="fixed bottom-6 right-6 z-50 flex items-center gap-3 rounded-lg border border-border bg-card shadow-lg px-4 py-3 text-sm text-foreground"
      role="status"
      aria-live="polite"
    >
      <span
        v-if="status === 'unsaved'"
        class="flex h-2 w-2 rounded-full bg-yellow-400 animate-pulse"
      ></span>
      <span
        v-else-if="status === 'saving'"
        class="flex h-2 w-2 rounded-full bg-blue-400 animate-spin"
      ></span>
      <span
        v-else-if="status === 'saved'"
        class="flex h-2 w-2 rounded-full bg-green-400"
      ></span>
      <span
        v-else-if="status === 'error'"
        class="flex h-2 w-2 rounded-full bg-red-400"
      ></span>

      <span class="font-medium">
        <template v-if="status === 'unsaved'">Unsaved changes</template>
        <template v-else-if="status === 'saving'">Saving…</template>
        <template v-else-if="status === 'saved'">All changes saved</template>
        <template v-else-if="status === 'error'">Failed to save changes</template>
      </span>
    </div>
  </transition>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'

interface Props {
  status: 'unsaved' | 'saving' | 'saved' | 'error'
}

const props = defineProps<Props>()

const visible = ref(false)
let hideTimer: number | null = null

watch(
  () => props.status,
  (newStatus) => {
    visible.value = newStatus !== 'saved'

    if (newStatus === 'saved') {
      visible.value = true
      if (hideTimer) clearTimeout(hideTimer)
      hideTimer = window.setTimeout(() => (visible.value = false), 2500)
    }

    if (newStatus === 'error') {
      visible.value = true
      if (hideTimer) clearTimeout(hideTimer)
    }
  },
  { immediate: true }
)
</script>